import { Pipe, PipeTransform } from '@angular/core';

/** Pipe for bytes display */
@Pipe({
	name: 'prettyBytes',
})
export class PrettyBytesPipe implements PipeTransform {
	transform(value: number): string {
		if (!value || typeof value !== 'number') {
			return `${value}`;
		}

		// filter items array, items which match and return true will be
		// kept, false will be filtered out
		return this.formatFileSize(value);
	}

	/**
	 * The util is used to format file size i.e., bytes to KB, MB, etc
	 * @param bytes
	 */
	formatFileSize(bytes) {
		if (bytes === 0) {
			return '0 Bytes';
		}
		const roundOffTo = 1;
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
		const unit = Math.floor(Math.log(bytes) / Math.log(1000));
		return parseFloat((bytes / Math.pow(1000, unit)).toFixed(roundOffTo)) + ' ' + sizes[unit];
	}
}
